import { inject, Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  private readonly snackBar = inject(MatSnackBar);


  notifyError(msg = 'There was an issue, try later'): void {
    this.notify(msg);
  }

  notify(msg: string): void {
    this.snackBar.open(msg, undefined, {
      duration: 3000,
    });
  }
}
